import React from "react";
import { DataGrid } from "@mui/x-data-grid";
import Box from "@mui/material/Box";
import "./ReuseableComponent.css";
const fDummy = () => {};
const GCToggleTableSearch = ({
  xMediaQuery = false,
  xrows,
  xcolumns = [],
  xRowCellClick,
  xRowClick,
}) => {
  return (
    <div className=" border">
      <div>
        <div
          style={{ height: xMediaQuery ? "40vh" : "80vh", width: "100%" }}
          id="table-main-grid-dropdown"
          className="search-grid-table "
        >
          <Box
            style={{ height: xMediaQuery ? "40vh" : "80vh", width: "100%" }}
            className=""
          >
            <DataGrid
              rowHeight={30}
              headerHeight={40}
              getRowClassName={(params) =>
                params.indexRelativeToCurrentPage % 2 === 0
                  ? "mui-even-row"
                  : "mui-odd-row"
              }
              sx={{
                border: 1,
                borderColor: "primary.light",
              }}
              rows={xrows}
              columns={xcolumns}
              onCellKeyDown={xRowCellClick ? xRowCellClick : fDummy()}
              onRowClick={xRowClick ? xRowClick : fDummy()}
              hideFooter={xrows.length < 100}
            />
          </Box>
        </div>
      </div>
    </div>
  );
};

export default GCToggleTableSearch;
